
import PrototypesDetailContainer from 'containers/PrototypesDetailContainer';

export default (props: any) => (
  <PrototypesDetailContainer {...props} edit={true} />
);
